export abstract class SearchResult {
  constructor(public name?: string, public id?: string, public iconName?: string) {}
  public abstract getPublisherId(): string;
  public abstract getAccountId(): string;
  public abstract getResourceType(): string;
}
